export default __webpack_public_path__ + "static/media/ico-mysql-score-moderate.dcb8eeb2.svg";